import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { ChatComponent } from './chat.component';
import { ChatStartComponent } from './chat-start/chat-start.component';
import { ChatViewComponent } from './chat-view/chat-view.component';
import { ChatLeftSidenavComponent } from './sidenavs/left/left.component';

const routes: Routes = [
  {
    path: ':shop_uuid/chat',
    component: ChatComponent,
    children: [],
  },
];

@NgModule({
  declarations: [ChatComponent],
  exports: [ChatComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    ChatLeftSidenavComponent,
    ChatViewComponent,
    ChatStartComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    CommonModule,
    NgxPermissionsModule,
    FuseDirectivesModule,
  ],
})
export class ChatModule {}
